export default "__VITE_ASSET__URjZCxIy__"